import React, { useState } from 'react';

import { OptionSwitch } from 'components';

import Export from './components/Export';
import Import from './components/Import';

import style from './ImportExportForm.module.scss';

const ImportExportForm = ({ closeModal }) => {
  const [isExport, setIsExport] = useState(true);

  return (
    <div className={style.container}>
      <OptionSwitch
        defaultOption={isExport}
        onChange={setIsExport}
        falseLabel={'Import'}
        trueLabel={'Export'}
      />
      {isExport ? <Export closeModal={closeModal} /> : <Import closeModal={closeModal} />}
    </div>
  );
};

export default ImportExportForm;
